import { getQuartzConfig } from 'quartz-config/evaluable';
const quartzConfig = getQuartzConfig();
if ( /* quartzConfig.type !== 'application' || quartzConfig.deprecated_disableOneDomain !== true */true) {
  // @ts-ignore untyped global variable
  window.hubspot['__hub-http-labs'] = window.hubspot['__hub-http-labs'] || {};

  // @ts-ignore untyped global variable
  window.hubspot['__hub-http-labs']['HUBONEDOMAIN'] = true;
}